module.exports = __webpack_public_path__ + "static/img/13.3c992d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/13.png
// module id = j3fi
// module chunks = 0